import { render, staticRenderFns } from "./videoUpload.vue?vue&type=template&id=04a0f4f1"
import script from "./videoUpload.vue?vue&type=script&lang=js"
export * from "./videoUpload.vue?vue&type=script&lang=js"
import style0 from "./videoUpload.vue?vue&type=style&index=0&id=04a0f4f1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports